import React, { FunctionComponent, useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import { RouteComponentProps } from "react-router-dom"
import { push } from "react-router-redux"
import { useDispatch, useSelector } from "react-redux"
import { login } from "../store/login-actions"
import { getUseSSO, isCloudApi } from "../../../data/api"
import { ApplicationState } from "../../../core/types"
import { Loading } from "../../Loading"

const BODY_THEME_CLASS = "btheme-welcome"

interface Props extends RouteComponentProps<{}> {
    search: string
}

export const AuthenticatedPage: FunctionComponent<Props> = (props: Props) => {

    useEffect(() => {
        document.body.classList.add(BODY_THEME_CLASS)
        return function cleanup() {
            document.body.classList.remove(BODY_THEME_CLASS)
        }
    })

    const dispatch = useDispatch()
    const errorMessage = useSelector<ApplicationState, string>( state => state.auth.errorMessage )

    const searchParams = new URLSearchParams(props.location.search)
    const code = searchParams.get("code")
    // Some IdPs (e.g. Auth0 federated through Cognito) redirect back with an
    // ?error param and no code instead of an authorization code.
    const ssoError = searchParams.get("error")

    useEffect(() => {
        if (getUseSSO() && code) {
            dispatch(login({code, username: "", password: ""}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Any callback failure — token exchange / user-fetch error, an IdP error
    // param, SSO disabled, or a missing code — sends the user back to /login
    // with an error flag instead of stranding them on this page with no exit.
    const failed = !!errorMessage || !!ssoError || !getUseSSO() || !code
    useEffect(() => {
        if (failed) {
            dispatch(push("/login?error=sso_failed"))
        }
    }, [failed, dispatch])

    return (
        <Container className="login-welcome-page container-welcome">
            <Row>
                <Col className="welcome-content" md={4}>
                    {/* Success path: token exchange is in progress. Show a
                        loading indicator rather than a blank column. On
                        failure the effect above redirects away. */}
                    { !failed && <Loading /> }
                </Col>
                <Col className="welcome-title" md={8}>
                    <h1 className="text-right mb-0">
                        <span className="display-2 d-block">Welcome to</span>
                        <span className="display-1">
                            { isCloudApi() ? "SMRT Link Cloud" : "SMRT Link" }
                        </span>
                    </h1>
                </Col>
            </Row>
        </Container>
    )
}
